import { HttpAxiosRequest } from '../httpAxiosBase'

export const HttpActions = {
    getEndpoint: (systemCode: number, url: string) => `Workflow/${systemCode}/Acciones${url}`,

    getActions: (systemCode: number) => HttpAxiosRequest.get(HttpActions.getEndpoint(systemCode, ''))
}
